import { IconStep, IconStep1, IconSuccess } from 'containers/Campaign/Progress/Assets';
import i18n from 'utils/i18n';

import { TCampaignCreatePage } from '../i18n/TModules';

export const progressPlaceholder = {
  level_icon: {
    type: 'image',
    value: IconStep1[0]
  },
  success_icon: {
    type: 'image',
    value: IconSuccess[0]
  },
  default_icon: {
    type: 'image',
    value: IconStep[0]
  }
};

export const progressDisplayPropertiesSuccess = {
  header: {
    level_tab: {
      value: {
        title: i18n.t(`${TCampaignCreatePage}.LandingPage.Levels`),
        points_abbreviation: i18n.t(`${TCampaignCreatePage}.LandingPage.PointsAbbreviation`)
      }
    },
    how_to_participate_tab: {
      value: { title: i18n.t(`${TCampaignCreatePage}.LandingPage.HowToParticipate`) }
    }
  },
  body: i18n.t(`${TCampaignCreatePage}.LandingPage.ParticipateAndWinExcitingPrizes`),
  milestones_success_image: {
    icon: progressPlaceholder.success_icon
  }
};

export const progressDisplayPropertiesFistLevel = {
  name: i18n.t(`${TCampaignCreatePage}.LandingPage.CompleteLevelAndStandToWinAPrizeSetIncluding`),
  display_properties: {
    icon: {
      type: 'image',
      ...progressPlaceholder.default_icon
    }
  },
  points: 0,
  outcomes: []
};
